class FileReaderHandler {
  constructor() {
    this.fileReader = new FileReader()  
  }

  readFileLineByLine(file, onReadLineCallback, onFinish) {
    this.fileReader.onload = () => {
      const fileLines = this.fileReader.result.split('\n')
      for (let currentLine = 0; currentLine < fileLines.length; currentLine++) {
        const currentLineContent = fileLines[currentLine]
        onReadLineCallback && onReadLineCallback(currentLineContent)
      }
      onFinish && onFinish()
    }
    this.fileReader.readAsText(file)
  }
}

export default FileReaderHandler



// WEBPACK FOOTER //
// ./src/utils/FileReaderHandler.js